// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Button, Icon, Typography } from '@material-ui/core';

const RedirectBack = ({ title, icon, onRedirect }) => (
  <div className="row d-flex flex-row justify-content-center">
    <div className="col-12 col-lg-12 d-flex flex-row align-items-center">
      <Button onClick={onRedirect} size="large">
        <Icon fontSize="large">{icon}</Icon>
      </Button>
      <Typography className="font-weight-bold" variant="h4" style={{ fontWeight: 'bold' }}>{title}</Typography>
    </div>
  </div>
);

export default RedirectBack;

RedirectBack.propTypes = {
  title:      PropTypes.string,
  icon:       PropTypes.string,
  onRedirect: PropTypes.func,
};

RedirectBack.defaultProps = {
  title:      '',
  icon:       'arrow_back',
  onRedirect: () => {},
};
